module.exports = __webpack_public_path__ + "img/icon_usercenter_collection.9c7b4382.png";